import { HOST_API_URL } from "../config";
import { TrySimplelanguages } from "../types/types";

export function GetSimpleLanguages(jsonString: string, url: string): TrySimplelanguages {

  const csharpCode = `using System;
using System.Net.Http;
using System.Threading.Tasks;

class Program
{
    static async Task Main()
    {
        using var client = new HttpClient();
        client.DefaultRequestHeaders.Add("Authorization", "Bearer YOUR_ACCESS_TOKEN");
        var content = new StringContent("${jsonString}", System.Text.Encoding.UTF8, "application/json");
        var response = await client.PostAsync("${HOST_API_URL}/${url}", content);
        response.EnsureSuccessStatusCode();
        var responseBody = await response.Content.ReadAsStringAsync();
        Console.WriteLine(responseBody);
    }
}`;

  const javaCode = `import okhttp3.MediaType;
import okhttp3.OkHttpClient;
import okhttp3.Request;
import okhttp3.RequestBody;
import okhttp3.Response;
import java.io.IOException;

public class Main {
    public static void main(String[] args) throws IOException {
        OkHttpClient client = new OkHttpClient();
        MediaType mediaType = MediaType.parse("application/json");
        RequestBody body = RequestBody.create("${jsonString}", mediaType);
        Request request = new Request.Builder()
            .url("${HOST_API_URL}/${url}")
            .post(body)
            .addHeader("Content-Type", "application/json")
            .addHeader("Authorization", "Bearer YOUR_ACCESS_TOKEN")
            .build();
        try (Response response = client.newCall(request).execute()) {
            if (response.isSuccessful()) {
                System.out.println(response.body().string());
            }
        }
    }
}`;

  const javascriptCode = `const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
myHeaders.append("Authorization", "Bearer YOUR_ACCESS_TOKEN");

const raw = JSON.stringify(${jsonString});

const requestOptions = {
  method: 'POST',
  headers: myHeaders,
  body: raw,
  redirect: 'follow'
};

fetch("${HOST_API_URL}/${url}", requestOptions)
  .then(response => response.text())
  .then(result => console.log(result))
  .catch(error => console.error('error', error));`;

  const phpCode = `<?php

$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => '${HOST_API_URL}/${url}',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'POST',
  CURLOPT_POSTFIELDS => '${jsonString}',
  CURLOPT_HTTPHEADER => array(
    'Content-Type: application/json',
    'Authorization: Bearer YOUR_ACCESS_TOKEN'
  ),
));

$response = curl_exec($curl);

curl_close($curl);
echo $response;
?>`;

  const pythonCode = `import requests

url = "${HOST_API_URL}/${url}"
headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer YOUR_ACCESS_TOKEN'
}
data = ${jsonString}

response = requests.post(url, headers=headers, json=data)
print(response.text)`;

  const languages: TrySimplelanguages = {
    Csharp: csharpCode,
    Java: javaCode,
    JavaScript: javascriptCode,
    PHP: phpCode,
    Python: pythonCode
  }

  return languages
}

export function GetSimpleLanguagesGET(url: string): TrySimplelanguages {

  const csharpCode = `using System;
using System.Net.Http;
using System.Threading.Tasks;

class Program
{
    static async Task Main()
    {
        using var client = new HttpClient();
        client.DefaultRequestHeaders.Add("Authorization", "Bearer YOUR_ACCESS_TOKEN");
        var response = await client.GetAsync("${HOST_API_URL}/${url}");
        response.EnsureSuccessStatusCode();
        var responseBody = await response.Content.ReadAsStringAsync();
        Console.WriteLine(responseBody);
    }
}`;

  const javaCode = `import okhttp3.OkHttpClient;
import okhttp3.Request;
import okhttp3.Response;
import java.io.IOException;

public class Main {
    public static void main(String[] args) throws IOException {
        OkHttpClient client = new OkHttpClient();
        Request request = new Request.Builder()
            .url("${HOST_API_URL}/${url}")
            .addHeader("Authorization", "Bearer YOUR_ACCESS_TOKEN")
            .build();
        try (Response response = client.newCall(request).execute()) {
            if (response.isSuccessful()) {
                System.out.println(response.body().string());
            }
        }
    }
}`;

  const javascriptCode = `const myHeaders = new Headers();
myHeaders.append("Authorization", "Bearer YOUR_ACCESS_TOKEN");

const requestOptions = {
  method: 'GET',
  headers: myHeaders,
  redirect: 'follow'
};

fetch("${HOST_API_URL}/${url}", requestOptions)
  .then(response => response.text())
  .then(result => console.log(result))
  .catch(error => console.error('error', error));`;

  const phpCode = `<?php

$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => '${HOST_API_URL}/${url}',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'GET',
  CURLOPT_HTTPHEADER => array(
    'Authorization: Bearer YOUR_ACCESS_TOKEN'
  ),
));

$response = curl_exec($curl);

curl_close($curl);
echo $response;
?>`;

  const pythonCode = `import requests

url = "${HOST_API_URL}/${url}"
headers = {
    'Authorization': 'Bearer YOUR_ACCESS_TOKEN'
}

response = requests.get(url, headers=headers)
print(response.text)`;

  const languages: TrySimplelanguages = {
    Csharp: csharpCode,
    Java: javaCode,
    JavaScript: javascriptCode,
    PHP: phpCode,
    Python: pythonCode
  }

  return languages
}